import React, { memo, useMemo, useEffect } from 'react'
import SectionTitle from '../SectionTitle'
import { ConfigurableContainer } from '../ConfigurableElement'
import { useUIConfig } from '../../hooks/useUIConfig'
import { useTranslation } from 'react-i18next'
import arabicBg from '../../images/arabic-bg-dark.svg'

import fIcon1 from '../../images/work/1.png'
import fIcon2 from '../../images/work/2.png'
import fIcon3 from '../../images/work/3.png'
import fIcon4 from '../../images/work/4.png'
import anasBotImg from '../../images/children/anas_bot.png'
import paperPlaneImg from '../../images/children/paper_plane.png'
import './style.css'

const Features = memo((props) => {
    const { t } = useTranslation();
    const { applyCSS } = useUIConfig();

    // Apply CSS when component mounts
    useEffect(() => {
        applyCSS();
    }, [applyCSS]);

    const features = useMemo(() => [
        {
            id: '1',
            fIcon: fIcon1,
            title: t('features.diverseActivities'),
        },
        {
            id: '2',
            fIcon: fIcon2,
            title: t('features.enrichedVocabularies'),
        },
        {
            id: '3',
            fIcon: fIcon3,
            title: t('features.completeVideoSuite'),
        },
        {
            id: '4',
            fIcon: fIcon4,
            title: t('features.songsAndTales'),
        },
    ], [t]);

    const renderFeatures = useMemo(() =>
        features.map((feature, index) => (
            <div className="col col-lg-3 col-md-6 col-12" key={feature.id}>
                <div className="wpo-work-iem">
                    <div className="wpo-work-icon-wrap">
                        <div className="wpo-work-icon">
                            <img src={feature.fIcon} alt={feature.title} loading="lazy" decoding="async" />
                        </div>
                        <div className="wpo-work-icon-thumb">
                            <span>{feature.id}</span>
                        </div>
                    </div>
                    <div className="wpo-work-text">
                        <h4>{feature.title}</h4>
                    </div>
                </div>
            </div>
        )), [features]);

    return (
        <section
            id="features"
            className={`wpo-work-section section-padding ${props.wClass}`}
            style={{
                position: 'relative'
            }}
        >
            {/* Arabic Background */}
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundImage: `url(${arabicBg})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    opacity: 0.05,
                    zIndex: 0
                }}
            />
            <div className="container" style={{ position: 'relative', zIndex: 1 }}>
                <SectionTitle subTitle={t('features.keyFeatures')} MainTitle={t('features.learningUnits')} vTitle={''} />
            </div>
            <div className="container" style={{ position: 'relative', zIndex: 1 }}>
                <div className="wpo-work-wrap">
                    <div className="row">
                        {renderFeatures}
                    </div>
                </div>
            </div>

            {/* Anas Bot image positioned at bottom left corner */}
            <ConfigurableContainer
                section="features"
                element="anasBot"
                className="features-bot-container"
            >
                <img src={anasBotImg} alt={t('features.anasBotAlt')} className="features-bot-img" loading="lazy" decoding="async" />
            </ConfigurableContainer>

            {/* Paper plane image positioned at top left corner */}
            <ConfigurableContainer
                section="features"
                element="paperPlane"
                className="features-paper-plane-container"
            >
                <img src={paperPlaneImg} alt={t('features.paperPlaneAlt')} className="features-paper-plane-img" loading="lazy" decoding="async" />
            </ConfigurableContainer>
        </section>
    )
});

export default Features;